'use strict';

var processInclude = require('./util');
var plpTileGallerySlick = require('./search/plpTileGallerySlick');

$(document).ready(function () {
    processInclude(require('./product/quickView'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/productTileSlider'));
    plpTileGallerySlick.init();
});
